import React, { useEffect } from "react";

import {
  NoSignalContainer,
  NoSignalContent,
  OPWrapper,
  NoSignalBox,
} from "./NoSignalStyled";
import useSound from "use-sound";
import notify from "../../../audio/noSignal.mp3";

export function NoSignal({
  // Globals,
  errorMsg,
  // errorBtn,
  reload,
  userSettings: { sound, volume },
}) {

  const [notifySfx] = useSound(notify, { volume });
  useEffect(() => {
    if (sound) notifySfx();
  }, [sound, notifySfx]);
  return (
    <NoSignalContainer>
      <OPWrapper>
        <NoSignalBox>
          <NoSignalContent reload={reload}>
            <p>{errorMsg}</p>
          </NoSignalContent>
        </NoSignalBox>
      </OPWrapper>
    </NoSignalContainer>
  );
}

// import React, { useEffect } from "react";
// import { Globals } from "../../../lib/constants";

// import { Signal, Title, Connect } from "./NoSignalStyled";
// import poorConection from "../../../audio/Poor connection.wav";

// export const NoSignal = props => {
//   useEffect(() => {
//     if (props.sound) {
//       let poorConections = new Audio(poorConection);
//       poorConections.autoplay = true;
//     }
//   });
//   return (
//     <Signal>
//       <Title>
//         <div>
//           <p>No Signal</p>
//         </div>
//       </Title>
//       ​<Connect onClick={() => Globals.WS.Start()}>reconnect</Connect>
//     </Signal>
//   );
// };
